/* eslint-disable react/destructuring-assignment */
/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
import React, { useEffect, useState } from 'react';
import Pagination from '@material-ui/lab/Pagination';
import { toast } from 'react-toastify';
import {
  CardSearch, ContainerPagination, ContainerLoading,
} from './styles';
import Header from '../../components/header';
import SearchBar from '../../components/searchBar';
import ItemsList from '../../components/itemListPlace';
import Container from '../../components/container';
import { useStyles } from '../../constants/styles';
import axios from '../../services/axiosServicesPoleposition';
import { Criterios } from '../../interfaces';
import LoadingCommon from '../../components/LoadingCommon';

const Place = (props: any) => {
  const [page, setPage] = useState<number>(1);
  const [pageSelected, setPageSelected] = useState(1);
  const [dataToPage, setDataToPage] = useState<Array<Criterios>>([]);
  const [search, setSearch] = useState('');
  const [disabled, setDisabled] = useState(false);
  const [data, setData] = useState<Array<Criterios>>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const getData = async () => {
    try {
      setLoading(true);
      const payload: {
        PaginaAtual: number;
        TotalItensRetorno: number;
        CodigoCategoriaLocal?: number | undefined
      } = {
        PaginaAtual: 1,
        TotalItensRetorno: 20,
      };
      const response = await axios.get('admin/criterios/v1', { params: payload });
      const { data: criterios } = response?.data;
      setData(criterios);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const checkStatus = async (status: boolean, id: string) => {
    if (status) {
      await inactiveDiscration(id);
    } else {
      await activeDiscration(id);
    }
  };

  const inactiveDiscration = async (id: string) => {
    try {
      axios.put(`admin/criterios/v1/desativar/${id}`);
      setDataToPage(dataToPage.map((item) => {
        if (item.idCriterio === id) {
          item.ativo = !item.ativo;
          return item;
        }

        return item;
      }));
      toast.success('Critério desativado com sucesso!');
    } catch (error) {
      toast.error('⚠ Não foi possível desativar o critério!');
    }
  };

  const activeDiscration = async (id: string) => {
    try {
      axios.put(`admin/criterios/v1/ativar/${id}`);
      setDataToPage(dataToPage.map((item) => {
        if (item.idCriterio === id) {
          item.ativo = !item.ativo;
          return item;
        }
        return item;
      }));
      toast.success('Critério ativado com sucesso!');
    } catch (error) {
      toast.error('⚠ Não foi possível desativar o critério!');
    }
  };

  const paginate = () => {
    const pages: number = data.length / 7;
    setPage(Math.ceil(pages));
    setPageSelected(1);
  };

  const handleChange = (_e: any, _page: number) => {
    const newPage = _page * 7;
    setDataToPage(
      data.filter((_item, index) => index >= newPage - 7 && index < newPage),
    );
    setPageSelected(_page);
  };

  const firtPage = () => {
    const newPage = 1 * 7;
    setDataToPage(
      data.filter(
        (_item: Criterios, index) => index >= newPage - 7 && index < newPage,
      ),
    );
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    paginate();
  }, [data]);

  useEffect(() => {
    firtPage();
  }, [data]);

  useEffect(() => {

  }, [disabled]);

  return (
    <Container component="main" maxWidth="xl">
      <div className={useStyles().containerLocal}>
        <Header label="Critérios" />
        {loading ? (
          <ContainerLoading>
            <LoadingCommon />
          </ContainerLoading>
        ) : null}
        <CardSearch>
          {!loading && (<SearchBar value={search} setValue={setSearch} />)}
        </CardSearch>
        {!loading && (
          dataToPage?.filter((item: any) => {
            if (search) {
              return (
                (item?.nome || '')
                  .toUpperCase()
                  .indexOf(search.toUpperCase()) !== -1
              || (item?.endereco || '')
                .toUpperCase()
                .indexOf(search.toUpperCase()) !== -1
              || (item?.bairro || '')
                .toUpperCase()
                .indexOf(search.toUpperCase()) !== -1
              );
            }
            return true;
          }).map((item: Criterios) => (
            <ItemsList
              type="rules"
              activeOrInative={() => checkStatus(item.ativo, item.idCriterio)}
              key={item.idCriterio}
              setDataToPage={setDataToPage}
              isActive={item.ativo}
              setDisabled={setDisabled}
              disabled={disabled}
              id={item.idCriterio}
              submit={() => {
                props.history.push('/novo-criterio', { nomeDiscration: item.nome, edit: true, id: item.idCriterio });
              }}
              nome={item.nome}
              description={item.descricao}
              url={`data:image/jpeg;base64,${item.iconeBase64}`}
            />
          ))
        )}
        {!loading && (
          <ContainerPagination>
            <Pagination
              style={{ marginTop: 15, marginBottom: 20 }}
              count={page}
              page={pageSelected}
              onChange={handleChange}
              color="standard"
            />
          </ContainerPagination>
        )}
      </div>
    </Container>
  );
};
export default Place;
